import React from "react";
import { useState } from 'react';
//React Router
import { useNavigate } from 'react-router-dom'

// tools and component for date picker
import dayjs from 'dayjs';

//selectors for redux :
import { useSelector } from "react-redux";
import { getIdSpot, getLivraison, getRidingPeriod, getPanier, getUserData, getCommentaire } from "../../../../store/selectors.js";
import { useDispatch } from "react-redux";
import { contratSlice } from "../../../../store/contratSlice.js";

//MUI Components
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Alert from '@mui/material/Alert';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';

//import Fetch API functions
import { getArticles, getOneSpot, getAllTarifs, getContrat } from '../../../../database/fetchApi.js'

//created components
import BlocRecap from '../../components/blocrecap/BlocRecap.jsx'

//Utils functions
import { prepareDureeTexte } from '../../../../utils/calcul_duree.js'
import calculDuree from '../../../../utils/calcul_duree.js' //we import this method because there is a bug to store the duree in Redux (infinite loop)
import { calcPrixDegressif } from "../../../../utils/calcul_prix.js" //parms : tarifs object, duree object
import { prepAdresse } from '../../../../utils/prepa_adresse_paiement.js'; //url preparation for axepta
import prepaMail from "../../../../utils/prepa-mail.js" //params : fullContrat 

// API fetch
import axios from "axios";
import { baseURL, cloudRunBaseURL } from '../../../../config/api-config.js';

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function StepFive() { // component to manage the first step of shopping : choosing place and time

    const [articles, setArticles] = useState([]);
    const [tarifs, setTarifs] = useState([]);
    const [spotInfos, setSpotInfos] = useState(null); //null is set by default so we can 
    const [fail, setFail] = useState(false); //state : api request failed
    const [infos, setInfos] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [ref, setRef] = React.useState("");
    const [contratID, setContratID] = React.useState();
    const [paymentUrl, setPaymentUrl] = useState(""); //state : api request failed
    let successRequest = 0;

    const idSpot = useSelector(getIdSpot); //global state : id of the selected spo
    const infosLivraison = useSelector(getLivraison); //global state : id of the selected spo
    const period = useSelector(getRidingPeriod); //global state : id of the selected spo
    const userInfos = useSelector(getUserData); //global state : id of the selected spo
    let panier = useSelector(getPanier); //get global state : panier
    let commentaire = useSelector(getCommentaire); //get global state : panier
    const lang = useSelector(getLang) //global state : language
    const dureeObject = calculDuree(period); //get object with quantity for every durations (demis,jour, semaine...)

    const dispatch = useDispatch();
    const navigate = useNavigate();


    React.useEffect(() => { //change opening hours when spot change (idspot as dependency)

        async function initArticles() { //we add this inner function to manage asynchrone
            let allArticles = await getArticles();
            setArticles([].concat(allArticles))
        } //end of async function
        initArticles(); //call the inner asnchrone function

        async function initSpot() { //we add this inner function to manage asynchrone
            let infosSpot = await getOneSpot(idSpot);
            setSpotInfos(infosSpot)
        } //end of async function
        initSpot(); //call the inner asnchrone function 

        async function initTarifs() { //we add this inner function to manage asynchrone
            let allTarifs = await getAllTarifs();
            setTarifs(allTarifs)
        } //end of async function
        initTarifs(); //call the inner asnchrone function 

        console.log("rendu");
    }, [])





    let periode = useSelector(getRidingPeriod);

    function findArticle(id) {
        try {
            return articles.find((item) => item.id_article === id);

        }
        catch {
            //console.log('error find')
        }
    }

    function getCumul() {
        let total = 0;
        let lignes = [];

        if (panier.length > 0) {
            panier.map((ligne) => {
                let articleCourant = findArticle(ligne.id_article);
                if (typeof articleCourant !== 'undefined') {
                    let pu = ligne.qte * calcPrixDegressif(articleCourant.Tarif, calculDuree(periode));
                    //let infosArticle = ligne.qte + " x " + articleCourant.type + " : " + pu + ",00€";
                    let infosArticle = { qte: ligne.qte, type: articleCourant.type, pu };
                    total += pu;
                    lignes.push(infosArticle);
                }
            });
        }

        return { total, lignes };
    }

    function getUserInfos(infos) { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
        return (
            <div className="bloc-recap-infos-user">
                <p>{infos.prenom} {infos.nom}</p>
                <div className="bloc-recap-infos-user-bloc">
                    <p>{infos.tel}</p>
                    <p>{infos.email}</p>
                </div>
                <div className="bloc-recap-infos-user-bloc">
                    <p>{infos.adresse}, {infos.adresse_comp}</p>
                    <p>{infos.cp}, {infos.ville}, {infos.pays}</p>
                </div>



            </div>
        )
    }

    function getPeriodInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

        let dateDeb = "";
        let dateFin = "";
        let duree = "";

        //prepare dates infos
        dateDeb += "du " + dayjs(period[0][0]).format("DD/MM/YYYY");
        dateDeb += " à " + period[1][0] + "h00";
        dateFin += " au " + dayjs(period[0][1]).format("DD/MM/YYYY");
        dateFin += " à " + period[1][1] + "h00";

        //Prepare duree infos
        duree = prepareDureeTexte(dureeObject);

        return (
            <div className="bloc-recap-infos-duree">
                <p className="bloc-recap-infos-duree-date">{dateDeb}</p>
                <p className="bloc-recap-infos-duree-date">{dateFin}</p>
                <p className="bloc-recap-infos-duree-cumul">soit : {duree}</p>
            </div>
        )
    }

    function getSpotInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

        let spot1 = "";
        let spot2 = "";

        // prepare spot infos
        if (idSpot >= 99) {
            spot1 = "Livraison : " + infosLivraison.secteur; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
            spot2 = infosLivraison.adresse; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
        }
        else { // spot is not livraion
            if (spotInfos) { // if promise not fullfilled yet, we block the process to evoid error
                spot1 = spotInfos.nom_spot;
                spot2 = spotInfos.adresse_spot + " " + spotInfos.ville_spot;
            }
        }

        return (
            <div className="bloc-recap-infos-spot">
                <p>{spot1}</p>
                <p>{spot2}</p>
            </div>
        )
    }

    function getLivraisonComp(comp) {
        let info = " ";
        info += comp === undefined ? "" : comp;
        return info;
    }

    function getCartInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
        let { total, lignes } = getCumul();

        return (
            <div className="bloc-recap-infos-cart">
                <div className="bloc-recap-infos-cart-top">
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Article</TableCell>
                                <TableCell align="center">Quantité</TableCell>
                                <TableCell align="center">Tarif</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lignes.map((row) => (
                                <TableRow
                                    key={row.type}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.type}
                                    </TableCell>
                                    <TableCell align="center">{row.qte}</TableCell>
                                    <TableCell align="center">{row.pu},00€</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                </div>
                <div className="bloc-recap-infos-cart-total">
                    <h3>Montant total du panier :</h3>
                    <p>{total},00 €</p>
                </div>
                <div className="bloc-recap-infos-cart-bottom">
                    {
                        commentaire.length > 1 ? //display only if commentaire is set
                            <>
                                <h3>Commentaires :</h3>
                                <p>{commentaire}</p>
                            </>
                            : null
                    }

                </div>



            </div>
        )
    }



    function insertClient() {
        //Add or update user
        if (userInfos.found) { // user already in db, we update
            axios.put(`${baseURL}/client/${userInfos.id_client}`, {
                email: userInfos.email,
                prenom: userInfos.prenom,
                nom: userInfos.nom,
                adresse: userInfos.adresse,
                adresse_comp: userInfos.adresse_comp,
                cp: userInfos.cp,
                ville: userInfos.ville,
                country: userInfos.pays
            })
                .then((response) => {
                    if (response.status === 200) { //isnertion OK
                        successRequest++;
                        insertContrat(response.data.data[0])
                    }
                    else { //insertion problème
                        return response.status
                    }
                })
                .catch(error => {
                    setFail(true); //to trigger alert message
                    return error
                })

        }
        else { //new user, we create
            axios.post(`${baseURL}/client`, {
                tel: userInfos.tel.split(" ").join(""),
                email: userInfos.email,
                prenom: userInfos.prenom,
                nom: userInfos.nom,
                adresse: userInfos.adresse,
                adresse_comp: userInfos.adresse_comp,
                cp: userInfos.cp,
                ville: userInfos.ville,
                country: userInfos.pays
            })
                .then((response) => {
                    if (response.status === 201) { //isnertion OK
                        insertContrat(response.data.data)
                    }
                    else { //insertion problème
                        setFail(true); //to trigger alert message
                        return response.status
                    }
                })
                .catch(error => {
                    setFail(true); //to trigger alert message
                    return error
                })
        }

    }

    function insertContrat(dataClient) {

        const today = dayjs();
        setRef(generateRefContrat(dataClient.id_client)); //save ref in state for paiement check

        let body = {
            ref_contrat: generateRefContrat(dataClient.id_client),
            client_id: dataClient.id_client,
            spot_id: idSpot,
            date1: period[0][0],
            date2: period[0][1],
            h1: period[1][0],
            h2: period[1][1],
            total: getCumul().total,
            solde: getCumul().total,
            commentaire: commentaire,
            commentaire2: "",
            date_crea: today.format('YYYY-MM-DD'),
            resa: true,
            paye: 0,
            retour: false,
            livraison: idSpot >= 99,
            adresse_livraison: idSpot >= 99 ? infosLivraison.secteur + "," + infosLivraison.adresse + "," + getLivraisonComp(infosLivraison.comp) : "-",
            garantie: ""
        }

        axios.post(`${baseURL}/contrat`, body)
            .then((response) => {
                if (response.status === 201) { //isnertion OK
                    successRequest++;
                    insertLignes(response.data)
                }
                else { //insertion problème
                    setFail(true); //to trigger alert message
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                return error
            })

    }


    function insertLignes(dataContrat) {
        /*  console.log(dataContrat.data.id_contrat);
         console.log(dataContrat); */
        setContratID(dataContrat.data.id_contrat);

        panier.map((ligne) => { // for each article of the panier...
            let rendus = [];
            for (let i = 1; i <= ligne.qte; i++) { //init defaut rendu array according to qty
                rendus.push(0); //0 by default = false
            }

            let body = {//prepare the json body sent in request
                article_id: ligne.id_article,
                contrat_id: dataContrat.data.id_contrat,
                qte: ligne.qte,
                taille: ligne.tailles,
                prenom: ligne.prenoms,
                rendu: rendus
            }

            axios.post(`${baseURL}/contrat-article`, body)
                .then((response) => {
                    if (response.status === 201) { //isnertion OK
                        successRequest++;
                        setFail(false); //to not trigger alert message
                        console.log(response.data)

                    }
                    else { //insertion problème
                        setFail(true); //to trigger alert message
                        return response.status
                    }
                })
                .catch(error => {
                    setFail(true); //to trigger alert message
                    return error
                })

        })//end of map
        goPay(dataContrat);
    }

    function generateRefContrat(idClient) {
        let refContrat = "";

        let formattedIdClient = String(idClient); //formater id client
        formattedIdClient = formattedIdClient.padStart(4, "0");

        let date1 = new Date(period[0][0]); //decouper date de début contrat
        let j1 = String(date1.getDate());
        j1 = j1.padStart(2, "0");
        let m1 = String(date1.getMonth() + 1);
        m1 = m1.padStart(2, "0");
        let y1 = String(date1.getFullYear());
        y1 = y1.slice(2); //on garde que les années après 2000 (on slice jusqu'à 2)


        //console.log("date1 :"+date1+" j1: "+j1+" m1: "+m1+" y1: "+y1);

        let date2 = new Date(); //date du jour
        let j2 = String(date2.getDate());
        j2 = j2.padStart(2, "0");
        let m2 = String(date2.getMonth() + 1);
        m2 = m2.padStart(2, "0");
        let s2 = String(date2.getSeconds());
        s2 = s2.padStart(2, "0");
        let ms2 = String(date2.getMilliseconds());
        ms2 = ms2.padStart(4, "0");


        refContrat = refContrat.concat(idSpot, "-", j1, m1, y1, "-", formattedIdClient, "-", j2, m2, "-", s2, ms2);
        return refContrat;
    }

    function goPay(dataContrat) {
        //dispatch(shoppingStepSlice.actions.nextShoppingStep()); //go to CGV
        console.log(successRequest)

        if (!fail) { //all the 3 request (client, contrat, lignes) are successfull
            //setFail(false);
            getPaymentUrl(dataContrat)
        }
        else {
            setFail(true);
        }


    }

    function getPaymentUrl(dataContrat) {
        console.log(dataContrat)
        setPaymentUrl(prepAdresse(dataContrat.data.ref_contrat, dataContrat.data.id_contrat, dataContrat.data.total, userInfos));

    }


    async function handleSearch() {
        setOpen(true);
        window.localStorage.setItem("axepta_resp", "fail");

        let contrat = [];
        let limit = 100; //maximum loops for waiting response from API
        let loopDurationInSeconds = 3; //loop duration in seconds
        let i = 0; //current number of loops
        let found = false;


        const loopId = setInterval(() => {
            setInfos("recherche");

            //detect paiement par modif valeur localstorage
            const repLocalStorage = window.localStorage.getItem("axepta_resp");
            console.log(repLocalStorage);
            if (repLocalStorage !== "fail") {
                found = true;
                contrat = [{ Code: "0000", contrat_id: parseInt(repLocalStorage) }];
                i = limit;
                console.log("paiement trouvé par recherche localStorage");
                window.localStorage.removeItem("axepta_resp");

            }



            try {
                axios.get(cloudRunBaseURL + "paiement/" + /* ref  */contratID, { validateStatus: false })
                    .then((response) => {
                        // console.log(response.status, i);
                        if (response.status === 404) {
                            //i++;
                            //let reponse = await getContrat(ref);
                            getContrat(ref).then((reponse2) => {
                                if (reponse2.length > 0) {
                                    if (reponse2[0].paye === 1) {
                                        found = true;
                                        contrat = [{ Code: "0000", contrat_id: reponse2[0].id_contrat }];
                                        i = limit;
                                        console.log("paiement trouvé par recherche contrat")
                                        console.log(reponse2.data)
                                    }
                                    else {
                                        i++;
                                    }
                                }
                            });
                        }
                        else //payment found
                        {
                            found = true;
                            contrat = [].concat(response.data.data);
                            i = limit;
                            console.log("paiement trouvé par recherche paiement")
                            console.log(response.data.data)

                        }
                    });

            }
            catch (error) {
                i = limit;
                console.log(error);
            }
            finally {
                if (i === limit) {
                    //console.log("recherche terminée");
                    managePaymentSearch(found, contrat);
                    clearInterval(loopId);
                }
            }

        }, loopDurationInSeconds * 1000);//end of set interval
    }




    function managePaymentSearch(found, infosPaiement) {
        //console.log(infosPaiement);
        let errorCode = "";
        if (infosPaiement.length > 0) { errorCode = infosPaiement[0].Code.charAt(0); } //on recup le digit de confirmation du paiement (0->ok)
        if (found && errorCode === "0") {
            setInfos("foundok");

            //mettre à jour le contrat :
            // paye = 1
            // solde = 0
            axios.put(`${baseURL}/contrat/${infosPaiement[0].contrat_id}`, {
                solde: 0,
                paye: 1
            })
                .then((response) => {
                    if (response.status === 200) { //isnertion OK
                        // mettre le contrat dans le global state pour la step6

                        //// -- remplir caisee
                        fillCaisse(response.data.data); //remplir les infos de caisse
                        dispatch(contratSlice.actions.setContrat(response.data.data)); //
                        //sendMail(response.data.data);
                    }
                    else { //insertion problème
                        return response.status
                    }
                })
                .catch(error => {
                    return error
                })





        } // end of payment ok
        else {
            setInfos("foundfail");
            // bouton ressayer :
            // on ouvre un nouveau onglet avec PaymentUrl
            // toutes les autres infos sont déjàas ds la table (contrat, client, lignes)
        }
    }

    function retryPayment() {
        setPaymentUrl("");
        setOpen(false);
    }

    function fillCaisse(fullContrat) {

        axios.post(`${baseURL}/caisse`, {
            contrat_id: fullContrat.id_contrat,
            ref_contrat: fullContrat.ref_contrat,
            type_paiement: 1,
            montant: fullContrat.total,
            date_paiement: fullContrat.date_crea
        })
            .then((response) => {
                if (response.status === 201) { //isnertion OK
                    console.log(response.data)
                    navigate(`../resasuccess/${fullContrat.ref_contrat}/ok`);

                }
                else { //insertion problème
                    setFail(true); //to trigger alert message
                    navigate(`../resasuccess/${fullContrat.ref_contrat}/fail`);
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                return error
            })
    }


    // modal opening state
    const handleClose = () => setOpen(true); // on ne peu pas fermer la modale, on attends

    function sendMail(fullContrat) {
        let body = {
            to: fullContrat.Client.email,
            bcc: "sylvainboufflers2@gmail.com,manuel.vivion@gmail.com",
            subject: "[Reservation vélos] - contrat location " + fullContrat.ref_contrat,
            html: prepaMail(fullContrat, articles, dureeObject, tarifs)
        };

        axios.post(`${baseURL}/mailing/mail-confirm`, body)
            .then((response) => {
                setOpen(false) // --> fermer modal 

                if (response.status === 200) { //isnertion OK
                    //setFail(false); //to not trigger alert message
                    //console.log("mail ok");

                    //// ---
                    navigate(`../resasuccess/${fullContrat.ref_contrat}/ok`);
                    /// --

                }
                else { //insertion problème
                    //setFail(true); //to trigger alert message
                    //console.log("mail pas ok");
                    //// ---
                    navigate(`../resasuccess/${fullContrat.ref_contrat}/fail`);
                    /// --
                }
            })
            .catch(error => {
                setOpen(false) // --> fermer modal 
                // setFail(true); //to trigger alert message
                // console.log("mail pas ok");
                //// ---
                navigate(`../resasuccess/${fullContrat.ref_contrat}/fail`);
                /// --

            })
    }


    return (
        <div className="step5">
            <div className="step5-top">
                <h1>{translator("Recapitulatif de votre commande avant paiement", lang, "step5Title")}</h1>
            </div>
            <div className="step5-blocs">
                <div className="step5-blocs-left">
                    <BlocRecap step={2} edit={true} titre={translator("Vos articles :", lang, "step5TitleArticles")} infos={getCartInfos()} />
                </div>
                <div className="step5-blocs-right">
                    <BlocRecap step={1} edit={true} titre={translator("Votre point de location :", lang, "step5TitleSpot")} infos={getSpotInfos()} />
                    <BlocRecap step={1} edit={true} titre={translator("Durée de location :", lang, "step5TitleDuree")} infos={getPeriodInfos()} />
                    <BlocRecap step={3} edit={true} titre={translator("Vos informations :", lang, "step5TitlePersonalInfos")} infos={getUserInfos(userInfos)} />
                </div>

            </div>

            <div className="step5-bottom">
                {fail ?
                    <Alert
                        className="step5-bottom-alert"
                        severity="error">{translator("Une erreur réseau s'est produite, nous ne pouvons passer au paiement.", lang, "step5Error")}

                    </Alert>
                    : null
                }

                {paymentUrl === "" ?
                    <Button
                        disabled={false}
                        className="bouton-valid-cmd"
                        variant="contained"
                        onClick={_ => insertClient()}
                    >{translator("Valider la commande", lang, "step5Valider")}
                    </Button>
                    :
                    <div>
                        <Alert
                            className="step5-bottom-alert"
                            severity="success">{translator("Votre réservation est enregistrée. Passez au paiement pour la valider.", lang, "step5ResaOk")}

                        </Alert>
                        <Alert
                            className="step5-bottom-alert"
                            severity="info">{translator("Une fois le paiement confirmé par votre banque, cliquez sur 'retour à la boutique' si cette option vous est proposée.", lang, "step5Boutique")}

                        </Alert>
                        <a href={paymentUrl} target="_blank" rel="noreferrer">
                            <Button
                                disabled={false}
                                className="bouton-gopay"
                                variant="contained"
                                onClick={_ => handleSearch()}>
                                {translator("passer au paiement", lang, "step5Valider2")}
                            </Button>
                        </a>
                    </div>
                }



            </div>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <div className="waiter-dialog">
                    {infos === "recherche" &&
                        <div className="waiter-dialog-recherche">
                            <h3>{translator("En attente de votre paiement", lang, "step5Attente1")}</h3>
                            <CircularProgress />
                            <p>{translator("Nous attendons la confirmation de paiement de la part de la banque...", lang, "step5Attente2")}</p>
                            <Alert
                                className="waiter-dialog-recherche-alert"
                                severity="warning">{translator("Ne fermez pas, ou ne rafrâichissez pas, cette fenêtre tant que le paiement n'a pas été confirmé.", lang, "step5Attente3")}

                            </Alert>

                        </div>
                    }

                    {infos === "foundok" &&
                        <div className="waiter-dialog-trouve">
                            <div className="waiter-dialog-trouve-success">
                                <h3>{translator("Paiement confirmé", lang, "step5PaiementOk1")}</h3>
                                <p>{translator("Nous avons bien reçu votre paiement. Vous allez être redirigé", lang, "step5PaiementOk2")}</p>

                            </div>
                        </div>
                    }

                    {infos === "foundfail" &&
                        <div className="waiter-dialog-trouve">
                            <div className="waiter-dialog-trouve-fail">
                                <h3>{translator("Erreur Paiement", lang, "step5PaiementError1")}</h3>
                                <p>{translator("Votre paiement n'a pas été reçu ou il y'a eu une erreur.", lang, "step5PaiementError2")}</p>
                                <p>{translator("Vous pouvez faire un nouvel essai si vous le souhaitez", lang, "step5PaiementError3")}</p>
                                <Button
                                    disabled={false}
                                    className="bouton-gopay"
                                    variant="contained"
                                    onClick={_ => retryPayment()}>
                                    {translator("Réessayer", lang, "step5PaiementRetry")}
                                </Button>
                            </div>
                        </div>
                    }







                </div>
            </Modal>

        </div>

    )
}




export default StepFive